import { getDefaultSuggestion } from '../api';
import * as TYPES from './types';
export default {
    [TYPES.SET_CUSTOMIZED_CITY](payload) {
        this.customizedCity = (payload || []).map(
            ({ name, keyName, key, type }) => {
                const label = name || keyName;
                const value = key;
                return {
                    label,
                    value,
                    type
                };
            }
        );
    },
    [TYPES.SET_IS_EXACT_SEARCH](payload) {
        this.isExactSearch = payload;
    },
    [TYPES.SET_PROPERTY_CONFIGS](payload = []) {
        this.propertyConfigs = [...payload];
    },
    [TYPES.SET_SEARCH_CHARTS](payload) {
        this.searchCharts = Array.isArray(payload)
            ? [...payload]
            : { ...payload };
    },
    [TYPES.SET_SEARCH_DATA](payload = []) {
        //  Middle platform 
        this.searchData = [...payload];
    },
    // [TYPES.SET_SHOW_LOCATION]( payload) {
    //     //  Middle platform 
    //     this.showLocation = payload;
    // },
    [TYPES.SET_LOCATION_SUGGESTION_URL](payload) {
        this.locationSuggestionUrl = payload;
    },
    [TYPES.SET_KEYWORD](payload) {
        this.keyword = payload;
    },
    [TYPES.SET_KEYWORD_TYPE](payload) {
        this.keywordType = payload;
    },
    [TYPES.SET_LOCATION_PLACEHOLDER](payload) {
        this.locationPlaceholder = payload;
    },

    async [TYPES.FETCH_DEFAULT_SUGGESTION]() {
        let res = await getDefaultSuggestion.call(this);
        let { customizedCity, searchCharts, locationPlaceholder } = res;
        this[TYPES.SET_SEARCH_CHARTS](searchCharts);
        this[TYPES.SET_CUSTOMIZED_CITY](customizedCity);
        locationPlaceholder = locationPlaceholder
            .map(({ name, nameText }) => nameText || name)
            .filter(Boolean)
            .join(', ');
        this[TYPES.SET_LOCATION_PLACEHOLDER](locationPlaceholder);
    }
};
